import React, { useEffect, useState } from "react";
import { useNavigate, useOutletContext } from "react-router";
import DataTable from "../../../components/Common/DataTable/DataTable";
import { useFetchData } from "../../../hooks/useFetchData";
import { useDispatch } from "react-redux";
import {
  getManageTranscriptionActionHandler,
  transcribeShotclassActionHandler,
} from "../../../store/actions/actionHandlers/manageActionHandler";
import { manageTranscription } from "../../../utils/mainTabs/manage/manageTranscription";
import { useCallback } from "react";
import { setErrorHandler } from "../../../store/actions/actionHandlers/errorActionHandler";
import { errorTypes } from "../../../utils/errorTypes";

const ManageTranscription = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { tenantName, refreshAPIS, setRefreshAPIS  } = useOutletContext();
  const pageSize = 8;

  const [tableColumns, setTableColumns] = useState([]);

  const {
    data,
    setData,
    updatedData,
    setUpdatedData,
    totalRows,
    loading,
    searchQuery,
    handleCurrentPage,
    handleSearchQuery
  } = useFetchData(getManageTranscriptionActionHandler, pageSize);
  const { columns } = manageTranscription;
  useEffect(() => {
    if (refreshAPIS) {
      handleSearchQuery("");
      setRefreshAPIS(false);
    }
  }, [refreshAPIS]);
  const handleTranscribe = useCallback(
    (shotclassId) => {
      dispatch(transcribeShotclassActionHandler(shotclassId)).then(
        (response) => {
          if (response) {
            let filteredData = data.map((shotclass) => {
              if (shotclass.course_id === shotclassId) {
                return {
                  ...shotclass,
                  TranscribeStatus: "Started Processing..",
                };
              } else {
                return shotclass;
              }
            });
            setData(filteredData);
            let filteredUpdatedData = updatedData.map((shotclass) => {
              if (shotclass.course_id === shotclassId) {
                return {
                  ...shotclass,
                  TranscribeStatus: "Started Processing..",
                };
              } else {
                return shotclass;
              }
            });
            setUpdatedData(filteredUpdatedData);
            dispatch(
              setErrorHandler(
                errorTypes.SUCCESS,
                `Transcribe process successfully started for class : ${
                  data.find((shotclass) => shotclass.course_id === shotclassId)
                    .Name
                }`
              )
            );
          }
        }
      );
    },
    [dispatch, data, setData, setUpdatedData, updatedData]
  );

  useEffect(() => {
    let newTableColumns = columns(navigate, handleTranscribe, tenantName);
    setTableColumns(newTableColumns);
  }, [columns, navigate, handleTranscribe, tenantName]);

  return (
    <DataTable
      columns={tableColumns}
      defaultData={data}
      setDefaultData={setData}
      data={updatedData}
      setData={setUpdatedData}
      totalRows={totalRows}
      loading={loading}
      uniqueFieldName={"course_id"}
      fetchMoreData={handleCurrentPage}
      searchable
      searchQuery={searchQuery}
      setSearchQuery={handleSearchQuery}
    />
  );
};

export default ManageTranscription;
